import Dashboard from "../components/admin/Dashboard/Dashboard";
import AdminLayout from "../components/admin/Layouts/AdminLayout";
import Settings from "../components/admin/Settings/Settings";
import GestionSubjects from "../components/admin/Subjects/GestionSubjects";
import Login from "../components/auth/Login";
import LandingPage from "../components/LandingPage/LandingPage";
import Subjects from "../components/Subjects/Subjects";

const AdminRoutes = [
	{ path: "dashboard", element: <Dashboard /> },
	{ path: "sujets", element: <GestionSubjects /> },
	{ path: "parametres", element: <Settings /> },
];

export const AppRoutes = [
	{ path: "/", element: <LandingPage /> },
	{ path: "sujets", element: <Subjects /> },
	{ path: "se-connecter", element: <Login /> },
	{
		path: "admin",
		element: <AdminLayout />,
		children: AdminRoutes,
	},
];
